export enum PropertyConsumptionType {
  WATER = 'WATER',
  ENERGY = 'ENERGY',
}
